"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deconstruct_number_format_1 = require("./deconstruct-number-format");
var format_number_1 = require("./format-number");
function formatNumberWithString(value, requiredFormat, overrideOptions) {
    var deconstructedFormat;
    if (requiredFormat) {
        deconstructedFormat = deconstruct_number_format_1.deconstructNumberFormat(requiredFormat.trim());
    }
    value = (value === null ? '' : value);
    value = value + ''; //make a string
    value = value.length ? value.trim() : '';
    var format;
    if (deconstructedFormat) {
        format = format_number_1.default({
            negativeType: deconstructedFormat.negativeType,
            negativeLeftSymbol: deconstructedFormat.negativeLeftSymbol,
            negativeRightSymbol: deconstructedFormat.negativeRightSymbol,
            negativeLeftOut: deconstructedFormat.negativeLeftPos === 0,
            negativeRightOut: deconstructedFormat.negativeRightPos === 0,
            prefix: deconstructedFormat.prefix,
            suffix: deconstructedFormat.suffix,
            integerSeparator: deconstructedFormat.integerSeparator,
            decimalsSeparator: deconstructedFormat.decimalsSeparator,
            decimal: deconstructedFormat.decimalChar,
            padLeft: deconstructedFormat.padLeft,
            padRight: deconstructedFormat.padRight,
            round: deconstructedFormat.maxRight,
            truncate: undefined
        });
    }
    else {
        format = format_number_1.default({
            negativeLeftOut: false,
            negativeRightOut: false,
            truncate: undefined
        });
    }
    return format(value, overrideOptions);
}
exports.default = formatNumberWithString;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/localizers/format-number-with-string.js
// module id = 455
// module chunks = 0 1 2 3 4 5 6